import React, { useState, useEffect } from 'react'
import * as R from 'ramda'
import { getCorrectSimilarPropertyObject } from '../utils'
import { Link } from 'gatsby'
import { v4 } from 'uuid'
import Image from './Image'

const SimilarProperties = ({ properties, title, propertyObject }) => {
  const [hasMounted, setHasMounted] = useState(false);

  useEffect(() => {
    setHasMounted(true);
  }, []);

  if (!hasMounted) {
    return null;
  }
  
  const updatedPropertyArray = R.reject((item) => item.node.frontmatter.title === title, properties);
  let random = updatedPropertyArray.sort(() => .5 - Math.random()).slice(0, 4);
  const mappedProperties = random.map((property) => (
    <div className="hover-zoom column is-6 similar-property" key={v4()}>
      <Link to={property.node.fields.slug}>
        <Image imageInfo={{ image: property.node.frontmatter.featuredImage }} classes="similar-properties-image" />
        <div className="similar-property-overlay">
          <div className="similar-property-overlay-text">
            <h4 className="title similar-property-title">{property.node.frontmatter.title}</h4>
            <div className="similar-property-text">{getCorrectSimilarPropertyObject(property.node.frontmatter, propertyObject).short_description}</div>
          </div>
        </div>
      </Link>
      </div>

  ));  
  return (
    <div className="columns similar-property-container is-multiline is-gapless">
      { mappedProperties }
    </div>
  );
}

export default SimilarProperties;